import * as React from 'react'

import { GridBox } from '../../../atoms/Box/Box'
import { MODAL_SEPARATOR_CONFIG, MODAL_SPACES } from '../config/modal.config'

type TGridProps = PropsOf<typeof GridBox>
type TProps = RequiredChildren &
  TGridProps & {
    withSeparator?: boolean
  }

const SEPARATOR_BORDER = `${MODAL_SEPARATOR_CONFIG.size} ${MODAL_SEPARATOR_CONFIG.color} solid`

/**
 * ModalHeader is a component that is used to render the header of a modal
 * that usually contains the title.
 * It’s not based on MUI component (there isn’t any) but just on a GridBox.
 */
export const ModalHeader: React.FC<TProps> = ({
  children,
  withSeparator = false,
  ...gridProps
}) => {
  return (
    <GridBox
      padding={MODAL_SPACES.lg}
      paddingBottom={MODAL_SPACES.md}
      borderBottom={withSeparator ? SEPARATOR_BORDER : 'unset'}
      {...gridProps}
    >
      {children}
    </GridBox>
  )
}
